import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListRetirableGrants$ } from "../schemas/schemas_0";
export { $Command };
export class ListRetirableGrantsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "ListRetirableGrants", {})
    .n("KMSClient", "ListRetirableGrantsCommand")
    .sc(ListRetirableGrants$)
    .build() {
}
